import { api } from '@/services/network/api';
import { authorizedApi } from '@/services/network/authorized-api';
import { signInWithEmail } from './session';
import { Page } from '@/domains';
import { formatISO } from 'date-fns';

export const signUpWithInvitation = (
  firstName: string,
  lastName: string,
  email: string,
  password: string,
  invitationToken: string
) =>
  api
    .post(`/users`, {
      firstName,
      lastName,
      email,
      password,
      invitationToken
    })
    .then((_) => signInWithEmail(email, password));

export const fetchUsers = (
  page: number,
  size: number,
  filter?: {
    organisationId: string | null;
    vendorId: string | null;
    term: string | null;
    joinedAfter: Date | null;
    joinedBefore: Date | null;
  }
) =>
  authorizedApi.get<Page<User>>(`/admin/users`, {
    ...(filter?.organisationId && { organizationId: filter.organisationId }),
    ...(filter?.vendorId && { vendorId: filter.vendorId }),
    ...(filter?.term && { search: filter.term }),
    ...(filter.joinedAfter && { joinedAfter: formatISO(filter.joinedAfter, { representation: 'date' }) }),
    ...(filter.joinedBefore && { joinedBefore: formatISO(filter.joinedBefore, { representation: 'date' }) }),
    pageNumber: page,
    pageSize: size
  });

export const fetchUserDetail = (id: string) => authorizedApi.get<User>(`/admin/users/${id}`);
